(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["labor-day-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('labor-day-countdown')) {
    customElements.define(
      'labor-day-countdown',
      class extends HTMLElement {
        connectedCallback() {
          this.end = new Date(this.dataset.end).getTime();
          this.days = this.querySelector('[data-days]');
          this.hours = this.querySelector('[data-hours]');
          this.minutes = this.querySelector('[data-minutes]');
          this.seconds = this.querySelector('[data-seconds]');
          this.countdown = this.querySelector(
            '.labor-day-bar__countdown'
          );
          this.expiredMessage = this.querySelector(
            '[data-expired-message]'
          );

          this.update();

          this.timer = window.setInterval(
            () => this.update(),
            1000
          );
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
        }

        update() {
          const remaining = this.end - Date.now();

          if (!Number.isFinite(this.end) || remaining <= 0) {
            window.clearInterval(this.timer);
            this.countdown.hidden = true;
            this.expiredMessage.textContent = this.dataset.expired;
            this.expiredMessage.hidden = false;
            return;
          }

          const pad = (value) => String(value).padStart(2, '0');

          this.days.textContent = pad(
            Math.floor(remaining / 86400000)
          );

          this.hours.textContent = pad(
            Math.floor((remaining % 86400000) / 3600000)
          );

          this.minutes.textContent = pad(
            Math.floor((remaining % 3600000) / 60000)
          );

          this.seconds.textContent = pad(
            Math.floor((remaining % 60000) / 1000)
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
